import { useTranslation } from 'react-i18next'

type PolicyNamespace = 'privacyPolicy' | 'cookiePolicy'
type PolicySection = { title: string; body: string }

const PolicyPage = ({ ns }: { ns: PolicyNamespace }) => {
  const { t } = useTranslation()
  const sections = (t(`${ns}.sections`, { returnObjects: true }) as PolicySection[]) ?? []

  return (
    <div className="tw-min-h-screen tw-font-figtree" style={{ background: 'var(--page-bg)' }}>
      <article className="tw-mx-auto tw-max-w-2xl tw-px-5 tw-py-12 sm:tw-py-16">
        <h1 className="tw-m-0 tw-text-3xl tw-font-bold tw-tracking-tight" style={{ color: 'var(--text-primary)' }}>
          {t(`${ns}.title`)}
        </h1>
        <div
          className="tw-mt-3 tw-h-1 tw-w-12 tw-rounded-full"
          style={{ background: 'linear-gradient(90deg, var(--primary-gradient-start), var(--primary-gradient-end))' }}
        />
        <p className="tw-mt-3 tw-text-xs" style={{ color: 'var(--text-tertiary)' }}>
          {t(`${ns}.updatedAt`)}
        </p>
        <p className="tw-mt-6 tw-text-[15px] tw-leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
          {t(`${ns}.intro`)}
        </p>

        {sections.map((section, i) => (
          <section key={i} className="tw-mt-8">
            <h2 className="tw-m-0 tw-text-lg tw-font-semibold" style={{ color: 'var(--text-primary)' }}>
              {section.title}
            </h2>
            {section.body.split('\n').map((paragraph, j) => (
              <p
                key={j}
                className="tw-mt-2 tw-text-[15px] tw-leading-relaxed"
                style={{ color: 'var(--text-secondary)' }}
              >
                {paragraph}
              </p>
            ))}
          </section>
        ))}
      </article>
    </div>
  )
}

export const PrivacyPolicyPage = () => <PolicyPage ns="privacyPolicy" />
export const CookiePolicyPage = () => <PolicyPage ns="cookiePolicy" />
